<app-auth-layout>
    <div class="cont">
        <img class="logo" src="./assets/images/logo.svg" />
          <app-error
            [errcode]="errcode"
          />
          <h1>Change email verification</h1>

          <sync-spinner *ngIf="spinner"></sync-spinner>
    
          <ng-container *ngIf="verified">
              <p>
                Your email address has been updated successfully.
              <a routerLink="/login">Log in to the control panel.</a>
            </p>
          </ng-container>

          <ng-container *ngIf="errcode">
            Changing your email failed. Please
            <a
                href="https://www.sync.com/support"
                >contact support</a
            >
            immediately for further assistance.
        </ng-container>
      </div>
</app-auth-layout>